import React from 'react';
import { HeroSection } from './components/HeroSection';
import { SocialProofSection } from './components/SocialProofSection';
import { DiagnosisSection } from './components/DiagnosisSection';
import { IdealClientSection } from './components/IdealClientSection';
import { CureSection } from './components/CureSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FinalCTA } from './components/FinalCTA';
import { ContactForm } from './components/ContactForm';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen bg-carbon font-sans overflow-x-hidden" data-id="element-0">
      <HeroSection data-id="element-1" />
      <SocialProofSection data-id="element-2" />
      <DiagnosisSection data-id="element-3" />
      <IdealClientSection data-id="element-4" />
      <CureSection data-id="element-5" />
      <GuaranteeSection data-id="element-6" />
      <FinalCTA data-id="element-7" />
      <ContactForm data-id="element-8" />
      <Footer data-id="element-9" />
    </main>;
}